<template>
  <v-navigation-drawer
      fixed
      permanent
      color="#101820"
      :mini-variant="!drawer"
      :mini-variant-width="80"
      :style="{ 'z-index': 1000 }"
      class="sidebar-menu"

  >
    <div style="display: flex; flex-direction: column; align-items: left; padding: 16px 0;">
      <v-avatar size="32" class="ml-6" >
          <v-img :src="require('../../src/assets/images-v2/icon_logikoss_color.png')"></v-img>
      </v-avatar>
      <v-btn icon @click="drawer = !drawer" color="white" class="mt-8 ml-5">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </div>
    <MenuItems :drawerState="drawer"></MenuItems>
  </v-navigation-drawer>
</template>

<script>
import MenuItems from './MenuItems'

export default {
  name: 'MenuSidebar',
  data () {
    return {
      drawer: false
    }
  },
  components: { MenuItems }
}
</script>

<style scoped>
  .sidebar-menu {
      height: 100vh !important;
      border-radius: 0 !important;
  }
</style>
